import { createContext as o, useContext as g, useState as l, useEffect as d, Children as s } from "react";
import { j as i } from "./jsx-runtime-B6kdoens.js";
import { c } from "./cn-BmFQLtkS.js";
const b = o({ stagger: !1 }), k = ({ children: r }) => {
  const { stagger: t } = g(b), [e, a] = l(!t);
  return d(() => {
    if (e)
      return;
    const n = requestIdleCallback(() => {
      a(!0);
    });
    return () => cancelIdleCallback(n);
  }, [e]), e ? r : s.toArray(r).slice(0, 3);
}, m = {
  green: "text-green-600",
  blue: "text-sky-600",
  yellow: "text-yellow-600",
  red: "text-red-600",
  purple: "text-purple-600",
  indigo: "text-indigo-600",
  gray: "text-gray-600"
}, p = {
  green: "bg-green-400 dark:bg-green-800",
  blue: "bg-sky-400 dark:bg-sky-800",
  yellow: "bg-yellow-400 dark:bg-yellow-800",
  red: "bg-red-400 dark:bg-red-800",
  purple: "bg-purple-400 dark:bg-purple-600",
  indigo: "bg-indigo-400 dark:bg-indigo-600",
  gray: "bg-gray-400 dark:bg-gray-600"
}, f = ({
  color: r,
  label: t,
  className: e
}) => /* @__PURE__ */ i.jsx(
  "span",
  {
    className: c(
      "mt-0.5 flex items-center duration-200 transition-opacity text-center uppercase font-mono text-[0.65rem] font-bold rounded text-background dark:text-zinc-50 h-4 px-1",
      p[r],
      e
    ),
    children: t
  }
);
export {
  b as S,
  m as T,
  f as a,
  k as b
};
//# sourceMappingURL=SidebarBadge-DxFJcJ6V.js.map
